import { ICONE } from 'icons'
import { BaseHeaderConIcona, BaseGridLayout } from 'layout'
import Indirizzo from './Indirizzo'

export default function HeaderIndirizzo(props) {
  const { indirizzo, ...restProps } = props
  const { presso, tipologiaEsterna = {} } = indirizzo

  return (
    <BaseHeaderConIcona
      icona={<ICONE.LUOGO />}
      titolo={<Indirizzo indirizzo={indirizzo} senzaBaseTesto />}
      sottotitolo={
        <BaseGridLayout vertical spacing={0}>
          <span key='presso' hidden={!presso}>
            Presso: {presso}
          </span>
          <span key='tipologiaEsterna' hidden={!tipologiaEsterna?.second}>
            Tipologia indirizzo: {tipologiaEsterna.second}
          </span>
        </BaseGridLayout>
      }
      {...restProps}
    />
  )
}
